<template>
  <div>
    <HeaderTop page="home" :isBackgroundShow="isBackgroundShow" :homeTitle="chineseTitle"></HeaderTop>
    <div class="content" @scroll="handleScroll">
      <div class="banner">
        <img :src="bannerImgUrl" alt="">
        <div class="menuTitle">
<!--          <div class="english">{{ englishTitle }}</div>-->
          <div class="english" :style="{'background-image': 'url('+bannerImgUrl+')'}">{{ englishTitle }}</div>
          <div class="chinese"> {{ chineseTitle.length > 10 ? chineseTitle.substr(0, 10) + '...' : chineseTitle }}</div>
        </div>
        <div class="tab" v-if="secondMenuList.length > 0 && pageWidth > 1280">
          <div class="tab_lst">
            <div v-for="(item, index) in secondMenuList" :key="index"
                 :class="[currentId == item.id ? 'tabItemAct':'','tabItem'].join(' ')" @click="toUp(item)">
              <span v-if="item.type != 1">{{
                  item.name.length > 10 ? item.name.substr(0, 10) + '...' : item.name
                }}</span>
            </div>
          </div>
        </div>
        <!--          <div class="tab">-->
        <!--            <div :class="[tabIndex==1?'tabItemAct':'','tabItem'].join(' ')">-->
        <!--                公司资讯-->
        <!--            </div>-->
        <!--            <div class="tabItem">-->
        <!--                行业资讯-->
        <!--            </div>-->
        <!--          </div>-->
      </div>
      <div v-if="pageWidth <= 1280" class="currenttitle">
        <span class="tt">{{ chineseTitle.length > 10 ? chineseTitle.substr(0, 10) + '...' : chineseTitle }}</span>
      </div>
      <div class="list">
        <div class="ul" v-if="newList.length > 0">
          <div class="li" v-for="(item, index) in newList" :key="index" @click="clickDetail(item)">
            <div class="left">
              <img :src="item.picpath" alt="">
            </div>
            <div class="right">
              <div class="conTitle">
                <div class="tt">{{ item.title }}</div>
                <div class="time">
                  {{ item.createtime }}
                </div>
              </div>
              <div class="intro">
                                {{ item.outline }}
              </div>
            </div>
          </div>

        </div>
      </div>
      <pagination :current="queryParams.pageNum" :pageSize="queryParams.pageSize" :total="pageTotal"
                  @pageChange="changPage" @toPageFirst="toPageFirst" @toPageLast="toPageLast"></pagination>
    </div>
    <float-element :showTop="showTop"></float-element>
    <Bottom></Bottom>
  </div>
</template>

<script>
import HeaderTop from "@/components/headerTop"
import Bottom from "@/components/bottom"
import Pagination from '@/components/pagination';
import FloatElement from "@/components/floatElement";

export default {
  name: "imglist",
  components: {
    HeaderTop,
    Bottom,
    Pagination,
    FloatElement
  },
  data() {
    return {
      pageWidth: 0,
      currentTitle: '',
      isBackgroundShow: true,
      currentId: '',
      newList: [],
      queryParams: {
        pageSize: 5,
        pageNum: 1
      },
      pageTotal: 0,
      secondMenuList: [],
      bannerImgUrl: '',
      parentid: '',
      grade: '',
      englishTitle: '',
      chineseTitle: '',
      showTop: false
    }
  },

  created() {
    this.currentId = this.$route.query.id
    this.grade = this.$route.query.grade
    this.parentid = this.$route.query.parentid
    this.getBannerImg() // 获取banner图
    this.getSecondMenuList()
    // if (window.screen.width < '1400'){
    //   document.write('<body style="zoom: 80%">');
    // }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll); // 移除滚动事件监听器
  },
  mounted() {
    this.pageWidth = document.documentElement.clientWidth
    window.addEventListener('scroll', this.handleScroll); // 添加滚动事件监听器
    this.getListFunc();
  },
  methods: {
    handleScroll(event) {
      const scrollTop = window.scrollY; // 获取滚动条相对于文档顶部的距离
      // 产品中心
      if (scrollTop >= 10) {
        // this.isBackgroundShow = true
        this.showTop = true
      } else {
        // this.isBackgroundShow = false
        this.showTop = false
      }
    },
    // 首页
    toPageFirst() {
      sessionStorage.setItem('currentPage', 1);
      this.queryParams.pageNum = 1
      this.getListData()
    },
    // 末页
    toPageLast() {
      var lastPageNumber = Math.ceil(this.pageTotal / this.queryParams.pageSize);
      sessionStorage.setItem('currentPage', lastPageNumber);
      this.queryParams.pageNum = lastPageNumber
      this.getListData()
    },
    // 保留分页
    getListFunc() {
      if (sessionStorage.getItem('information')) {
        this.queryParams.pageNum = Number(sessionStorage.getItem("currentPage"));
      } else {
        this.queryParams.pageNum = 1;
        sessionStorage.removeItem("currentPage");
      }
    },
    // 翻页
    changPage(page) {
      sessionStorage.setItem('currentPage', page);
      this.queryParams.pageNum = page
      this.getListData()
    },
    // 获取banner图
    getBannerImg() {
      this.$API.InterfaceConfigurationPage._getMenuList({
        params: {
          grade: 1
        }
      }).then(res => {
        if (res.success) {
          if (res.data == '[]') {
            this.bannerImgUrl = ''
          } else {
            res.data.forEach(item => {
              if (item.id == this.$route.query.parentid) {
                this.bannerImgUrl = item.picpath
              }
            })
          }
        } else {
          this.$Message.info('系统错误')
        }
      }).catch(err => {
        console.log('获取失败===', err);
      });
    },
    // 点击二级
    toUp(item) {
      this.currentId = item.id
      this.grade = item.grade
      this.parentid = item.parentid
      this.getSecondMenuList()
    },
    // 获取菜单列表
    getSecondMenuList() {
      var params = {}
      if (this.grade == 1) {
        params = {
          grade: 1
        }
      } else if (this.grade == 2) {
        params = {
          grade: 2,
          firstlevelid: this.parentid
        }
      }
      this.$API.InterfaceConfigurationPage._getMenuList({
        params: params
      }).then(res => {
        if (res.success) {
          this.secondMenuList = res.data.filter(item => item.type != 1)
          this.secondMenuList.forEach(item => {
            if (item.id == this.currentId) {
              this.englishTitle = item.en_name
              this.chineseTitle = item.name
            }
          })
          this.getListData()
        } else {
          this.$Message.info('系统错误')
        }
      }).catch(err => {
        console.log('获取失败===', err);
      });
    },
    // 获取列表
    getListData() {
      var params = {}
      if (this.grade == '2') {
        params = {
          secondlevelid: this.currentId,
          pagesize: this.queryParams.pageSize,
          pageindex: this.queryParams.pageNum
        }
      } else {
        params = {
          firstlevelid: this.currentId,
          pagesize: this.queryParams.pageSize,
          pageindex: this.queryParams.pageNum
        }
      }
      this.$API.InterfaceConfigurationPage._getArticleList({
        params
      }).then(res => {
        if (res.success) {
          this.newList = res.data
          this.pageTotal = res.totalcount
        } else {
          this.$Message.info('系统错误')
        }
      }).catch(err => {
        console.log('获取失败===', err);
      });
    },
    clickDetail(item) {
      this.$router.push({
        path: '/informationDynamicsDetail',
        query: {
          id: item.id,
          parentid: this.$route.query.parentid
        }
      })
    }
  }
}

</script>

<style scoped lang="less">

//移动端
.content {
  width: 100%;
  box-sizing: border-box;
  padding-bottom: 300px;

  .banner {
    width: 100%;
    position: relative;
    height: 400px;

    .menuTitle {
      position: absolute;
      top: 153px;
      text-align: left;
      padding-left: 30px;

      .english {
        font-family: D-DINExp-Bold;
        font-weight: bold;
        font-size: 50px;
        text-size-adjust: none;
        color: rgba(255, 255, 255, 0.2);
        position: relative;
        z-index: 99;
        background-repeat: no-repeat;
        background-clip: text;
        -webkit-background-clip: text;
      }

      .chinese {
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 42px;
        text-size-adjust: none;
        color: #FFFFFF;
        position: relative;
        z-index: 100;
        margin-top: -50px;
      }
    }

    img {
      width: 100%;
      height: 400px;
    }

    .tab {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 40px;
      display: flex;
      background: rgba(80, 118, 175, 0.8);

      .tabItem {
        width: 33.33%;
        text-align: center;
        line-height: 40px;
        font-size: 16px;
        text-size-adjust: none;
        color: #ccc;
        cursor: pointer;
      }

      .tabItemAct {
        color: #fff;
      }
    }
  }

  .currenttitle {
    .tt {
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 30px;
      text-size-adjust: none;
      color: #5280B6;
      text-align: center;
      position: relative;
    }

    .tt::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      height: 14px;
      background: rgba(82, 128, 182, 0.4);
      width: 100%;
    }

    margin-top: 29px;
  }

  .list {
    margin: 30px;

    .ul {
      width: 100%;

      .li {
        width: 100%;
        background: #EDF2F8;
        border-radius: 20px;
        display: flex;
        padding: 20px;
        margin-bottom: 30px;

        .left {
          width: 220px;
          height: 160px;
          border-radius: 20px;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .right {
          flex: 1;
          padding-left: 22px;
          text-align: left;

          .conTitle {
            display: flex;
            border-bottom: 1px solid #CCCCCC;
            padding-bottom: 20px;
            padding-top: 14px;

            .tt {
              font-family: Microsoft YaHei;
              font-weight: bold;
              font-size: 24px;
              text-size-adjust: none;
              color: #5280B6;
              display: -webkit-box; /* 将元素作为弹性容器 */
              overflow: hidden; /* 超出部分隐藏 */
              text-overflow: ellipsis; /* 使用省略号表示被裁切的内容 */
              -webkit-line-clamp: 1; /* 限定最大行数为2行 */
              -webkit-box-orient: vertical; /* 垂直布局 */
              flex: 1;
            }

            .time {
              font-family: Microsoft YaHei;
              font-weight: 400;
              font-size: 14px;
              text-size-adjust: none;
              color: rgba(82, 128, 182, 0.8);
              margin-top: 10px;
            }
          }

          .intro {
            padding-top: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 18px;
            text-size-adjust: none;
            color: #999999;
            display: -webkit-box; /* 将元素作为弹性容器 */
            overflow: hidden; /* 超出部分隐藏 */
            text-overflow: ellipsis; /* 使用省略号表示被裁切的内容 */
            -webkit-line-clamp: 2; /* 限定最大行数为2行 */
            -webkit-box-orient: vertical; /* 垂直布局 */
          }
        }
      }
    }
  }
}

//PC端
@media screen and (min-width: 1280px) {
  .content {
    width: 100%;
    box-sizing: border-box;
    padding-bottom: 0px;
    margin-top: 100px;

    .banner {
      width: 100%;
      height: 500px;
      position: relative;

      .menuTitle {
        width: 1400px;
        margin: 0 auto;
        margin-top: -388px;
        padding: 0;
        position: static;

        .english {
          font-family: D-DINExp-Bold;
          font-weight: bold;
          font-size: 65px;
          color: rgba(255, 255, 255, 0.2);
          position: relative;
          z-index: 99;
          background-repeat: no-repeat;
          background-clip: text;
          -webkit-background-clip: text;
        }

        .chinese {
          font-family: Microsoft YaHei;
          font-weight: bold;
          font-size: 54px;
          color: #FFFFFF;
          position: relative;
          z-index: 100;
          margin-top: -55px;
        }
      }

      img {
        width: 100%;
        height: 100%;
      }

      .tab {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 60px;
        display: flex;
        background: rgba(80, 118, 175, 0.8);

        .tab_lst {
          position: relative;
          width: 1400px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;

          .tabItem:first-child {
            text-align: left;
          }

          .tabItem:last-child {
            text-align: right;
          }

          .tabItem {
            text-align: center;
            line-height: 60px;
            font-size: 24px;
            color: rgba(255, 255, 255, 0.8);
            cursor: pointer;
            width: auto;
          }

          .tabItemAct {
            color: #fff;
            font-weight: bold;
          }
        }
      }
    }

    .list {
      width: 1400px;
      margin: 10px auto;


      .title {
        width: 210px;
        height: 31px;
        margin: 20px auto;
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 30px;
        color: #5280B6;
      }

      .ul {
        width: 100%;
        padding-top: 20px;

        .li {
          width: 100%;
          background: #EDF2F8;
          border-radius: 20px;
          display: flex;
          padding: 20px;
          margin-bottom: 30px;

          .left {
            width: 150px;
            height: 120px;
            border-radius: 20px;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .right {
            flex: 1;
            padding-left: 22px;
            text-align: left;
            overflow: hidden;
            cursor: pointer;

            .conTitle {
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp: 1;
              height: 40px;
              display: flex;
              justify-content: space-between;
              font-family: Microsoft YaHei;
              font-weight: bold;
              font-size: 24px;
              color: #5280B6;
              border-bottom: 1px solid #CCCCCC;
              padding: 0;

              .time {
                float: right;
                font-size: 13px;
                margin-top: 10px;
                color: rgba(82, 128, 182, 0.8);
                width: 79px;
              }

              .tt {
                flex: 1;
                font-family: Microsoft YaHei;
                font-weight: bold;
                font-size: 24px;
                color: #5280B6;
                padding: 0;
              }
            }

            .intro {
              display: -webkit-box; /* 将元素作为弹性容器 */
              overflow: hidden; /* 超出部分隐藏 */
              text-overflow: ellipsis; /* 使用省略号表示被裁切的内容 */
              -webkit-line-clamp: 3; /* 限定最大行数为2行 */
              -webkit-box-orient: vertical; /* 垂直布局 */
              padding-top: 8px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              font-size: 15px;
              color: #999999;

            }
          }

        }

      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/InformationDynamics.vue